import type { PrimeVueConfiguration } from 'primevue/config';
import { InterseguroAuraPreset } from './interseguro-aura-preset';

export const DEFAULT_IS_PRIMEVUE_OPTIONS: PrimeVueConfiguration = {
  theme: {
    preset: InterseguroAuraPreset,
    options: {
      prefix: 'is-uikit',
      darkModeSelector: '.is-dark-mode',
      cssLayer: false,
    },
  },
  ripple: true,
  inputVariant: 'outlined',
  locale: {
    accept: 'Sí',
    reject: 'No',
    cancel: 'Cancelar',
    apply: 'Aplicar',
    clear: 'Limpiar',
    searchMessage: 'Hay {0} resultados disponibles',
    emptySearchMessage: 'Sin resultados',
    emptyMessage: 'Sin opciones disponibles',
    today: 'Hoy',
    am: 'AM',
    pm: 'PM',
    dateFormat: 'dd/mm/yy',
    firstDayOfWeek: 1,
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB'],
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
    ],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    aria: {
      close: 'Cerrar',
      next: 'Siguiente',
      previous: 'Anterior',
      navigation: 'Navegación',
    },
  },
};
